import { render } from "./BuildingAreaFarmListEntryAction2.vue?vue&type=template&id=0b8a2a70"
import script from "./BuildingAreaFarmListEntryAction2.vue?vue&type=script&lang=js"
export * from "./BuildingAreaFarmListEntryAction2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/BuildingAreaFarmListEntryAction2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b8a2a70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b8a2a70', __exports__)) {
    api.reload('0b8a2a70', __exports__)
  }
  
  module.hot.accept("./BuildingAreaFarmListEntryAction2.vue?vue&type=template&id=0b8a2a70", () => {
    api.rerender('0b8a2a70', render)
  })

}


export default __exports__